var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { contains, equals } from "ramda";
import { Money } from "@upserve/financials";
import Modal from "components/modal";
import { DigitalGiftCardDeliveryMethod, } from "types/digital_gift_cards";
var success = require("images/icons/success-check.svg");
var StyledConfirmationModal = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 60px 30px 60px 30px;\n  overflow-y: auto;\n\n  font-size: 24px;\n\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    width: 80%;\n  }\n"], ["\n  padding: 60px 30px 60px 30px;\n  overflow-y: auto;\n\n  font-size: 24px;\n\n  text-align: center;\n\n  @media (max-width: 1024px) {\n    width: 80%;\n  }\n"])));
var StyledConfirmationHeader = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: \"Graphik\", sans-serif;\n  font-weight: bold;\n  font-size: 1.75rem; // ~24px based on 14px root font-size; decrease to 1.5rem for 16px root\n  color: #212322;\n"], ["\n  font-family: \"Graphik\", sans-serif;\n  font-weight: bold;\n  font-size: 1.75rem; // ~24px based on 14px root font-size; decrease to 1.5rem for 16px root\n  color: #212322;\n"])));
var StyledConfirmationContent = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n"])));
var StyledBoldContent = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
export default function ConfirmationModal(_a) {
    var orderResponse = _a.orderResponse, ccLastFour = _a.ccLastFour, closeModalClick = _a.closeModalClick;
    var digitalGiftCards = orderResponse.digitalGiftCards, consumerEmail = orderResponse.consumerEmail;
    var _b = digitalGiftCards[0], deliveryMethod = _b.deliveryMethod, recipient = _b.recipient, recipientEmail = _b.recipientEmail, recipientPhone = _b.recipientPhone, amount = _b.amount;
    var formattedPhone = recipientPhone
        ? recipientPhone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
        : "";
    var recipientInfo = contains(deliveryMethod, [
        DigitalGiftCardDeliveryMethod.EMAIL_RECEIPT,
        DigitalGiftCardDeliveryMethod.TEXT_RECEIPT,
    ]) && (React.createElement(React.Fragment, null,
        React.createElement("br", null),
        "Sent to:",
        React.createElement("br", null),
        React.createElement(StyledBoldContent, null, recipient),
        " at",
        " ",
        React.createElement(StyledBoldContent, null, equals(DigitalGiftCardDeliveryMethod.TEXT_RECEIPT, deliveryMethod)
            ? formattedPhone
            : recipientEmail)));
    return (React.createElement(Modal, { onClose: closeModalClick, className: "" },
        React.createElement(StyledConfirmationModal, null,
            React.createElement("img", { alt: "success", src: success, style: { width: "65px", height: "65px" } }),
            React.createElement(StyledConfirmationHeader, null, "Thank you!"),
            React.createElement(StyledConfirmationContent, null,
                React.createElement("div", null,
                    "Your card is on the way.",
                    React.createElement("br", null),
                    "Gift Card Amount:",
                    " ",
                    React.createElement(StyledBoldContent, null, Money(amount).format()),
                    recipientInfo,
                    React.createElement("br", null),
                    "Paid with card # ....",
                    ccLastFour),
                React.createElement("div", null,
                    "We'll send an email receipt to:",
                    React.createElement("br", null),
                    consumerEmail)))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
